import { Button, Flex, Text } from "@mantine/core";
import { IconArrowUpRight } from "@tabler/icons-react";
const referralUrl = "https://manta.referral-factory.com/UeFeb8";
const referralTrackUrl =
  "https://manta.referral-factory.com/UeFeb8/referrals";

const Referral = () => {
  const onGetReferralLink = () => {
    window.open(referralUrl, "_blank");
  };
  const onTrackReferral = () => {
    window.open(referralTrackUrl, "_blank");
  };
  return (
    <Flex
      direction={"column"}
      mt={60}
      w={250}
      mx={"auto"}
      justify={"center"}
      flex={1}
      h={"100%"}
    >
      <Button mb={10} onClick={onTrackReferral}>
        <Text>Track Referrals</Text>
      </Button>
      <Button onClick={onGetReferralLink}>
        <Text mr={5}>Get referral link</Text> <IconArrowUpRight size={"22"} />
      </Button>
    </Flex>
  );
};
export default Referral;
